// ═══════════════════════════════════════════════════════════════════════════════
// conTimeout — le pone un límite a una promesa que puede no resolver nunca.
//
// Motivo (incidentes 2026-08-27 y 2026-08-29): cuando el servicio de Auth de
// Supabase deja de responder, el fetch del navegador queda colgado sin error y
// sin límite propio. La promesa nunca se resuelve ni se rechaza, así que el
// `await` no vuelve, el `setBusy(false)` no corre y la pantalla se congela
// indefinidamente en "VERIFICANDO..." o "CONECTANDO CON LA BASE DE DATOS...".
// El usuario no tiene forma de distinguir eso de una app lenta.
//
// Esto no evita la caída: la convierte en un mensaje accionable.
// ═══════════════════════════════════════════════════════════════════════════════

export const TIMEOUT_MS = 15000;

// La carga inicial trae todo el laboratorio (órdenes, resultados con sus
// valores, cotizaciones…) y crece con el tiempo. Un límite de 15 s la cortaba
// aunque estuviera avanzando (23-oct-2026: 5,839 valores = 6 páginas ≈ 18 s).
// Su límite es más holgado; los puntos de Auth siguen con 15 s.
export const TIMEOUT_CARGA_MS = 45000;

export class TimeoutError extends Error {
  constructor(etiqueta) {
    super(`Tiempo de espera agotado: ${etiqueta}`);
    this.name      = 'TimeoutError';
    this.esTimeout = true;
    this.etiqueta  = etiqueta;
  }
}

export function conTimeout(promesa, etiqueta = 'la operación', ms = TIMEOUT_MS) {
  let t;
  const reloj = new Promise((_, reject) => {
    t = setTimeout(() => reject(new TimeoutError(etiqueta)), ms);
  });
  return Promise.race([promesa, reloj]).finally(() => clearTimeout(t));
}

// Texto único para todos los puntos de falla: la causa que importa al usuario
// es siempre la misma (el servidor no contestó), no el punto exacto del código.
export const MSG_TIMEOUT =
  'El servidor no respondió. Puede ser una caída temporal del servicio. Espera unos segundos y vuelve a intentar.';
